import type { SearchCriteria } from '@/entities/searchCriteria';
import CalendarMinPriceState from './CalendarMinPriceState';
import type { AlternativeSearchContext, AlternativeSearchState, AlternativeSearchView } from './types';
import { withFlexibleDates } from '../../lib/alternativeSearchCriteria';
import { hasSerpProducts } from '../../lib/toSerpProducts';

export default class FlexibleDatesState implements AlternativeSearchState {
  readonly criteria: SearchCriteria | null;

  private readonly unsubscribe: () => void;

  constructor(private readonly context: AlternativeSearchContext) {
    this.criteria = withFlexibleDates(context.userCriteria);

    this.unsubscribe = context.productSearch.on('end', (result) => {
      if (result.state !== 'finished' || hasSerpProducts(result)) return;

      context.setState(new CalendarMinPriceState(context));
    });
  }

  get view(): AlternativeSearchView | null {
    return this.criteria ? { kind: 'similar', criteria: this.criteria } : null;
  }

  start(): void {
    const { criteria, context } = this;

    if (!criteria) {
      context.setState(new CalendarMinPriceState(context));
      return;
    }

    context.productSearch.run(criteria);
  }

  dispose(): void {
    this.unsubscribe();
  }
}
